import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import LandpTable from './LandpTable';

function DayBook() {
  const colors = useColors();


  return (
    <div>
      <HeaderSection
        title="Profit and Loss" 
        breadcrumb={["Dashboard", "Accounts", "Profit and Loss"]} 
      />

      <HStack align="start" w="full"  gap="0"  p={2}>
        <LandpTable colors={colors} />

      </HStack>
    </div>
  );
}

export default DayBook;
